import { getAuctionPens } from "../root";

export const getAuctionPenById =
  (auctionPenId: string) =>
  (state: RootState): AuctionPen | null =>
    getAuctionPens(state)[auctionPenId] || null;
